$(document).ready(function() {
$( ".site-nav>li" ).append( "<span></span>" );/*add span in li*/

$(".site-nav > li span").click (function() {
  	$(this).toggleClass("mobile_active");
	$(this).parent().children(".mainNode_nav-columns").toggleClass("mega_active");
	$(this).parent().children(".mainNode_nav-columns").toggle();
});
			
 $(".site-nav > li").addClass(function(i){return "megamenu" + (i + 1);}); /*add class in li*/
			 
 $('.megamenu2_data .mainNode_nav-columns').appendTo('.site-nav .megamenu2'); /*add data in li*/
 $('.megamenu3_data .mainNode_nav-columns').appendTo('.site-nav .megamenu3'); /*add data in li*/
 $('.megamenu4_data .mainNode_nav-columns').appendTo('.site-nav .megamenu4'); /*add data in li*/
 $('.megamenu5_data .mainNode_nav-columns').appendTo('.site-nav .megamenu5'); /*add data in li*/
 $('.megamenu6_data .mainNode_nav-columns').appendTo('.site-nav .megamenu6'); /*add data in li*/
 $('.megamenu7_data .mainNode_nav-columns').appendTo('.site-nav .megamenu7'); /*add data in li*/
 $('.megamenu8_data .mainNode_nav-columns').appendTo('.site-nav .megamenu8'); /*add data in li*/
 $('.megamenu9_data .mainNode_nav-columns').appendTo('.site-nav .megamenu9'); /*add data in li*/
 $('.megamenu10_data .mainNode_nav-columns').appendTo('.site-nav .megamenu10'); /*add data in li*/
 $('.megamenu11_data .mainNode_nav-columns').appendTo('.site-nav .megamenu11'); /*add data in li*/
			
});